import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const LN = () => {
  return (
    <CardSection id="LN" title="LN">
      <Paragraph>
        숫자의 자연 로그를 반환합니다. 자연 로그는 상수{" "}
        <b>e(2.71828182845904)</b>를 기반으로 합니다. 이는 Excel의 LN 함수와
        동일한 출력을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>LN(NUMBER)</Paragraph>
        <Ul>
          <Li>
            <b>NUMBER</b>는 자연로그를 구하려는 양의 실수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>LN(`Column`)</Paragraph>
        <Img src="computeLn" />
      </ListSection>
    </CardSection>
  );
};
